import React from "react"
import Button from '@mui/material/Button';
import "./profileCard.scss";
import axios from "axios"
const ProfileCard = () => {
const [individualPatient, setIndividualPatient] = React.useState([]);

    React.useEffect(() =>{
        const getUserById = () => {
            axios.get("https://arogyanxtdevapi.fundaclear.in/api/v1/Patient/02167904-ff1b-4929-9bba-e1788eeaf8c1").
            then(res => {
                if(res?.status === 200)setIndividualPatient(res?.data?.result)
            }).catch(err => {console.error(err)})
        }
        getUserById()
    }, [])
    return (
        <div className="profile-card">
            <div className="profile-body col-sm d-flex">
                <div className="profile-img">
                    <img src="https://i.imgur.com/LohyFIN.jpg" className="rounded-circle" />
                    <i class="fa fa-edit"></i>
                </div>
                <div className="card-details">
                    <div className="name d-flex justify-content-between">
                        <h4 className="name-tag">{individualPatient?.basicDetail?.name}</h4>
                        <Button variant="contained" className="ml-5 btn-actve">Active</Button>
                    </div>
                    <div className="user-details">
                        <div className="d-flex">
                            <p className="key-tag">Age:</p>
                            <p className="ml-2 value-tag">{individualPatient?.basicDetail?.age}</p>
                        </div>
                        <div className="postion d-flex ml-5">
                            <p className="key-tag">Emr:</p>
                            <p className="value-tag">{individualPatient?.basicDetail?.emrNumber}</p>
                        </div>
                    </div>
                    <div className="email">
                        <div className="d-flex">
                            <p className="key-tag">Email:</p>
                            <p className="ml-2 value-tag">{individualPatient?.basicDetail?.email}</p>
                        </div>
                    </div>
                    <div className="email">
                        <div className="d-flex">
                            <p className="key-tag">Gender:</p>
                            <p className="ml-2 value-tag">{individualPatient?.basicDetail?.gender}</p>
                        </div>
                    </div>
                    <div className="email">
                        <div className="d-flex">
                            <p className="key-tag">Mobile:</p>
                            <p className="ml-2 value-tag">{individualPatient?.basicDetail?.mobile}</p>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
    )
}


export default ProfileCard;